import React from "react";
import DisplayAdOnPage from "shared/components/DisplayAdOnPage";
import Str from "shared/components/Str";

import { FORMATS_KEYS } from "shared/modules/onpageads/constants";

import "./Advertisement.scss";

const Advertisement = () => {
	return (
		<div className="discovery-ad">
			<div className="discovery-ad-container">
				<DisplayAdOnPage format={FORMATS_KEYS.LEADER_EXPANDED} />
			</div>
			<a
				href="/upgrade?cf=removeads&feature=comfree&source=discovery"
				className="discovery-ad-link"
			>
				<Str>Remove ads</Str>
			</a>
		</div>
	);
};

export default Advertisement;



// WEBPACK FOOTER //
// ./src/apps/discovery/components/interruptions/Advertisement.jsx